export default "__VITE_ASSET__CxPvPAAv__"